// import service from "../services/vehicle-trips-service";
import Service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  //
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    // return service
    //   .indexList(params)
    //   .then((data) => {
    //     store.commit("SET_META", data.body);
    //     store.commit("SET_LIST", data.body.data);
    //   })
    return Service.get(`vehicle/customer-vehicle-trips`, params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
      })
      .finally(() => (store.state.loading = false));
  },
  setLoadingValue: (store, value) => {
    store.commit("SET_LOADING", value);
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
};

const trips = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default trips;
